/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-events/content-control-studio-event/content-control-studio-event.component.scss */
.cursor-pointer {
  cursor: pointer;
}
:host {
  border-radius: 6px;
  border-style: solid;
  width: 100%;
  border-color: rgba(0, 0, 0, 0.14);
  border-width: 1px;
  padding: 8px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  align-items: flex-start;
  -webkit-user-select: none;
  user-select: none;
}
.event {
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  gap: 10px;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
  overflow: hidden;
}
.event .data {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-left: 15px;
}
.event .data .info {
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
  justify-content: center;
  display: flex;
  position: relative;
}
.event .data .info .timetrange {
  color: rgba(0, 0, 0, 0.54);
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  position: relative;
  -webkit-user-select: text;
  user-select: text;
}
.event .data .info .title {
  background-color: #ef5d5d;
  border-radius: 4px;
  padding: 0px 4px 0px 4px;
  display: flex;
  flex-direction: row;
  gap: 2px;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
}
.event .data .info .title.approved {
  background-color: #01b25d;
}
.event .data .info .title > span {
  color: rgb(255, 255, 255);
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  position: relative;
}
.event .data .info .action {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 10px;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
  position: relative;
}
.event .data .info .action .action-description {
  color: rgba(0, 0, 0, 0.85);
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 10px;
  line-height: 16px;
  font-weight: 400;
  text-transform: uppercase;
  position: relative;
  flex: 1;
}
.event .data .info .action .action-undo {
  background: rgb(235, 240, 244);
  border-radius: 2px;
  display: flex;
  flex-direction: row;
  gap: 4px;
  align-items: flex-start;
  justify-content: center;
  flex-shrink: 0;
  position: relative;
  cursor: pointer;
}
.event .data .info .action .action-undo > svg {
  width: 10px;
  height: 10px;
  position: relative;
}
.event .frames {
  display: flex;
  flex-direction: row;
  gap: 5px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
}
.event .frames img {
  border-radius: 4px;
  flex-shrink: 0;
  width: 82px;
  height: 46px;
  position: relative;
  object-fit: cover;
}
/*# sourceMappingURL=content-control-studio-event.component.css.map */
